enum ActivityType {
    /**
     * indicator for Txp Activity
     */
    TxpActivity,

    /**
     * Dining activity type
     */
    Dining,

    /**
     * Event activity type
     */
    EventActivityType,

    /**
     * Flight Departure activity type
     */
    FlightDeparture,

    /**
     * Hotel checkin activity type
     */
    HotelCheckin,

    /**
     * Hotel checkout activity type
     */
    HotelCheckout,

    /**
     * Invoice due activity type
     */
    InvoiceDue,

    /**
     * Parcel Delivery activity type
     */
    ParcelDelivery,

    /**
     * Rental car pick up activity type
     */
    RentalCarPickup,

    /**
     * Rental car drop off activity type
     */
    RentalCarDropOff,

    /**
     * Invoice scheduled activity type
     */
    InvoiceScheduled,

    /**
     * Service reservation activity type
     */
    ServiceAppointment,
}

export default ActivityType;
